import { createContext } from "react";
import { StoreApi } from "zustand";
import { FormData } from "@/components/forms/store/useFormData";
import { FormState } from "@/components/forms/store/useFormState";

export interface FormStores {
	formDataStore: StoreApi<FormData>;
	formStateStore: StoreApi<FormState>;
}

export const FormStoresContext = createContext<FormStores | null>(null);
